import { transitions } from 'polished'

const transition = (extend = []) => transitions(['color', 'background-color', ...extend], 'var(--speed) var(--ease)')
const variant = 'text.text'

export default {
  __default: {
    '--icon-size': '0.7em',
    position: 'relative',

    '& + &>hr.-top': {
      display: 'none',
    },
    '>hr': { transform: 'scale(1.001)' },

    '&[data-disabled=true]': { cursor: 'not-allowed' },

    '.Featured': {
      position: 'absolute',
      top: '0.8rem',
      right: '2.4rem',
      zIndex: '10',

      width: 'clamp(21rem, 20vw, 28rem)',
      pointerEvents: 'none',
      userSelect: 'none',

      transition: 'none',

      img: {
        borderRadius: 1,
        // borderBottomLeftRadius: 1,
        // borderBottomRightRadius: 1
      },
    },

    '@media (hover: hover)': {
      '&:not(:hover)': {
        '.Featured': { opacity: 0, visibility: 'hidden' },
      },
      '&:hover': {
        '--bullet-color': (t) => t.colors.text,
        // '.Featured': { display: 'block' },
      },
      '&[data-selected=true][data-static=false]>div': {
        px: '0.75rem',
      },
      // '&[data-selected=true][data-bg-trigger]>div': {
      //   bg: 'rgba(255,255,255,0.2)',
      // },
    },
    '&[aria-expanded=true]': {
      '--bullet-color': (t) => t.colors.text,
    },

    '>div': transition(['padding-left', 'padding-right', 'background-color']),
  },

  rte: {
    mt: '1em',
    mb: '2em',

    display: 'grid',
    gridTemplateColumns: ['1fr var(--icon-size)', '1fr 1fr var(--icon-size)'],
    gap: 1,
    '> *': {
      gridColumn: ['1/2', 'span 1'],
    },
    '&[data-multiple=false] > *': {
      gridColumn: ['1/2', 'span 2'],
      maxWidth: '850px',
    },
  },

  service_list: {
    article: {
      mt: '1em',
      mb: '2em',

      display: 'grid',
      gridTemplateColumns: ['1fr var(--icon-size)', '1fr 1fr var(--icon-size)'],
      gap: ['3rem', 1],

      '> *': {
        gridColumn: ['1/-1', '1/2', 'span 1'],
      },
      '&[data-multiple=false] > *': {
        gridColumn: ['1/-1', '1/2', 'span 2'],
        maxWidth: '850px',
      },

      '[data-element="list"]': {
        gap: '0.7rem',
        alignItems: 'flex-start',
      },
      '[data-element="content"]': {
        gap: '3rem',
        alignItems: 'flex-start',
      },
    },
  },

  jobs_list: {
    article: {
      mt: '1em',
      mb: '2em',

      display: 'grid',
      gridTemplateColumns: ['1fr var(--icon-size)', '1fr 1fr var(--icon-size)'],
      gap: ['3rem', 1],

      '> *': {
        gridColumn: ['1/-1', '1/2', 'span 1'],
      },
      '&[data-multiple=false] > *': {
        gridColumn: ['1/-1', '1/2', 'span 2'],
        maxWidth: '850px',
      },

      '[data-element="list"]': {
        gap: '0.7rem',
        alignItems: 'flex-start',
      },
      '[data-element="content"]': {
        gap: '3rem',
        alignItems: 'flex-start',
      },
      '[data-element="sep"]': {
        width: '100%',
        borderTop: (t) => `var(--stroke-x) solid ${t?.colors?.text}`,
      },
    },
  },

  head: {
    width: '100%',
    position: 'relative',

    gridTemplateColumns: 'repeat(var(--length, 1), 1fr) var(--icon-size)',
    gridColumnGap: 1,
    gridRowGap: 0,

    '&[data-standalone=true]': {
      gridTemplateColumns: 'repeat(calc(var(--length, 1) - 1), 1fr) auto',
    },
  },

  text: {
    variant,

    width: '100%',
    py: '1.5em',
    gridColumn: 'span 1',
  },

  icon: {
    position: 'absolute',
    gridColumn: 'calc(var(--length, 1) + 1)/-1',
    size: '100%',

    alignItems: 'center',

    aside: {
      '--size': 'var(--icon-size)',
      size: 'var(--size)',

      position: 'absolute',
      right: 0,

      borderRadius: '50%',
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'var(--bullet-color, unset)',

      bg: 'var(--bullet-color, unset)',

      ...transition(['transform', 'border-color']),
    },
  },
}
